import SisterPlayerComponent from './SisterPlayer';
export default SisterPlayerComponent;